export default {
  getProjectListWithCompany: '/api/project/getProjectListWithCompany', // 获取项目列表
  //项目负责人
  getProjectPrincipalList: '/api/projectPrincipal/getProjectPrincipalList', //获取列表table
  addProjectPrincipal: '/api/projectPrincipal/addProjectPrincipal', //添加项目负责人
  editProjectPrincipal: '/api/projectPrincipal/editProjectPrincipal', //编辑项目负责人
  delProjectPrincipal: '/api/projectPrincipal/delProjectPrincipal', //删除项目负责人
  //项目列表
  getProjectList: '/api/project/getProjectList', //获取项目列表table
  getProjectDelList: '/api/project/getProjectDelList', //获取已删除项目列表table
  addProject: '/api/project/addProject', //新增项目
  editProject: '/api/project/editProject', //修改项目信息
  delProject: '/api/project/delProject', //删除项目
  recoverProject: '/api/project/recoverProject', //恢复项目
  getProjectListByUser: '/admin/project/getProjectListByUser', //暂时不知道干啥的
  updateProjectStatus: '/api/project/updateProjectStatus', //更新项目状态

  addContractReceiptRecord: '/api/contractPaymentRecord/addContractReceiptRecord', //新增收款记录
};
